module.exports = __webpack_public_path__ + "assets/img/about-header.136c6629.png";